import { Mapper } from '../../../../../base/utils/mapper';
import { DemoBusinessModel } from '../../../../../domain/models/configuration/company/demo-business.model';
import { DemoBusinessEntity } from '../../entities/company/demo-business.entity';

export class DemoBusinessImplementationRepositoryMapper extends Mapper<
  DemoBusinessEntity,
  DemoBusinessModel
> {
  mapFrom(param: DemoBusinessEntity): DemoBusinessModel {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
  mapTo(param: DemoBusinessModel): DemoBusinessEntity {
    return {
      data: param.data,
      isSuccess: param.isSuccess,
      message: param.message,
      errors: param.errors,
    };
  }
}
